<!-- Schließen als X oben statt einer Leiste unten: jede Zeile, die nicht Dokument ist, kostet Höhe. -->
<div class="kopf">
  <!-- Fokus beim Oeffnen auf den Titel: sonst nimmt Material den ersten Knopf der Viewer-Leiste („Verkleinern"), und der steht mit Fokusring da. -->
  <h2 matDialogTitle tabindex="-1" cdkFocusInitial>{{ data.title }}</h2>
  @for (action of data.actions ?? []; track action.icon) {
    <button
      type="button"
      matIconButton
      [matTooltip]="action.tooltip"
      [attr.aria-label]="action.tooltip"
      (click)="runAction(action)"
      [disabled]="!pdfResource.hasValue()"
    >
      <mat-icon>{{ action.icon }}</mat-icon>
    </button>
  }
  <button type="button" matIconButton mat-dialog-close matTooltip="Schließen" aria-label="Schließen">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <lib-resource-loading class="laden" [resources]="[pdfResource]">
    @if (pdfResource.hasValue()) {
      <!-- Herunterladen und „In neuem Tab öffnen" stehen in der Leiste des Viewers. -->
      <lib-pdf class="dokument" [pdf]="pdfResource.value()" [fuellen]="true" [dateiname]="data.title" />
    }
  </lib-resource-loading>
</mat-dialog-content>
